module.exports = __webpack_public_path__ + "static/media/dementia-friends-logo.d0044cfd.png";